import categories from '#lib/data/categories.json';

// Map of service enum id (e.g. "joiner", "painter") → Norwegian label
// (e.g. "Snekker", "Maler"). Sourced from the single category list so the
// directory, profiles and postings all use the same names.
const SERVICE_LABELS: Record<string, string> = Object.fromEntries(
	(categories as Array<{ id: string; name: string }>).map((c) => [c.id, c.name])
);

/**
 * Localized Norwegian label for a service/trade enum id. Falls back to the raw
 * value so an unknown id is still shown rather than dropped - never render the
 * raw enum directly in the UI; use this.
 */
export function getServiceLabel(service: string): string {
	return SERVICE_LABELS[service] ?? service;
}
